const _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "cbd28076b3d6710a0a8d8aad0e393c7f77f5ed5b"
};